// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 
   Code Gen Name   Timers
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    DEVWARE/anthony.monsees
   Generate On     6/6/2023 1:04:43 PM
************************************************/

export enum TimersMetaDataItemNames {
    Timer = 'Timer',
    TimerSkillMap = 'TimerSkillMap',
    TimerStatus = 'TimerStatus',
    TimerType = 'TimerType',
}

export enum TimersMetaDataLookups {
    TimerAllItems = 2833,
    TimerSkillMapAllItems = 2839,
    TimerStatusAllItems = 2835,
    TimerStatusWithSort = 2836,
    TimerTypeAllItems = 2834,
}

@Injectable({
    providedIn: 'root'
})
export class TimersMetaDataService {

    Timer : Timer = new Timer();
    TimerSkillMap : TimerSkillMap = new TimerSkillMap();
    TimerStatus : TimerStatus = new TimerStatus();
    TimerType : TimerType = new TimerType();
}

// Generated Classes for MetaData service
class Timer implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Timer.';

    constructor() {
        this.ItemDetail.ItemId=2771;
        this.ItemDetail.ItemName='Timer';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerId : string = this.i + 'TimerId';
    TimerStatusId : string = this.i + 'TimerStatusId';
    TimerTypeId : string = this.i + 'TimerTypeId';
    EthosJobId : string = this.i + 'Ethos_JobId';
    TechEthosUserId : string = this.i + 'TechEthos_UserId';
    StartDateTime : string = this.i + 'StartDateTime';
    DueDateTime : string = this.i + 'DueDateTime';
    TimerMinutes : string = this.i + 'TimerMinutes';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    EthosJobSiteId : string = this.i + 'Ethos_JobSiteId';
    Notes : string = this.i + 'Notes';

    Relations = {
            /** Relation: Timer Type */
            TimerType : {
                RelationName: 'TimerType|Timer|TimerTypeId',
                FieldPrefix: 'TimerType',
                PropertyName: 'TimerType'
            },
            /** Relation: Timer Status */
            TimerStatus : {
                RelationName: 'TimerStatus|Timer|TimerStatusId',
                FieldPrefix: 'TimerStatus',
                PropertyName: 'TimerStatus'
            },
    };
}

class TimerSkillMap implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerSkillMap.';

    constructor() {
        this.ItemDetail.ItemId=2775;
        this.ItemDetail.ItemName='TimerSkillMap';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerSkillMapId : string = this.i + 'TimerSkillMapId';
    EthosSkillCv : string = this.i + 'EthosSkillCv';

    Relations = {
    };
}

class TimerStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerStatus.';

    constructor() {
        this.ItemDetail.ItemId=2773;
        this.ItemDetail.ItemName='TimerStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerStatusId : string = this.i + 'TimerStatusId';
    TimerStatus : string = this.i + 'TimerStatus';
    SortOrder : string = this.i + 'SortOrder';

    Relations = {
            /** Relation: Timer */
            Timer : {
                RelationName: 'TimerStatus|Timer|TimerStatusId',
                FieldPrefix: 'Timer',
                PropertyName: 'Timer'
            },
    };
}

class TimerType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TimerType.';

    constructor() {
        this.ItemDetail.ItemId=2772;
        this.ItemDetail.ItemName='TimerType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TimerTypeId : string = this.i + 'TimerTypeId';
    TimerType : string = this.i + 'TimerType';
    IsAscendingTimer : string = this.i + 'IsAscendingTimer';

    Relations = {
            /** Relation: Timer */
            Timer : {
                RelationName: 'TimerType|Timer|TimerTypeId',
                FieldPrefix: 'Timer',
                PropertyName: 'Timer'
            },
    };
}


export class TimersMetaData {

    static Timer : Timer = new Timer();
    static TimerSkillMap : TimerSkillMap = new TimerSkillMap();
    static TimerStatus : TimerStatus = new TimerStatus();
    static TimerType : TimerType = new TimerType();
}

// Generated Entity Interfaces
export interface TimerEntity extends DwOrmData {
    // Attributes
    TimerId?: number;
    TimerStatusId?: number;
    TimerTypeId?: number;
    Ethos_JobId?: number;
    TechEthos_UserId?: number;
    StartDateTime?: string;
    DueDateTime?: string;
    TimerMinutes?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Ethos_JobSiteId?: number;
    Notes?: string;

    // Display Attributes
    TimerStatusIdDisplay?: string;
    TimerTypeIdDisplay?: string;
    Ethos_JobIdDisplay?: string;
    TechEthos_UserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    Ethos_JobSiteIdDisplay?: string;
    // Relations
    TimerType? : TimerTypeEntity;
    TimerStatus? : TimerStatusEntity;
}

export interface TimerSkillMapEntity extends DwOrmData {
    // Attributes
    TimerSkillMapId?: number;
    EthosSkillCv?: number;

    // Display Attributes
    EthosSkillCvDisplay?: string;
    // Relations
}

export interface TimerStatusEntity extends DwOrmData {
    // Attributes
    TimerStatusId?: number;
    TimerStatus?: string;
    SortOrder?: number;

    // Relations
    Timer? : TimerEntity[];
}

export interface TimerTypeEntity extends DwOrmData {
    // Attributes
    TimerTypeId?: number;
    TimerType?: string;
    IsAscendingTimer?: boolean;

    // Relations
    Timer? : TimerEntity[];
}

// Generated Query Interfaces
/** Entity for Query Meaning Tech_Timers_List  */
export interface TechTimersListQueryEntity extends DwOrmData {
    // Attributes
    TimerId?: number;
    TimerStatusId?: number;
    TimerTypeId?: number;
    Ethos_JobId?: number;
    TechEthos_UserId?: number;
    StartDateTime?: string;
    DueDateTime?: string;
    TimerMinutes?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Ethos_JobSiteId?: number;
    Notes?: string;
    ResourceCity?: string;
    ResourceStateProvinceShortName?: string;
    RoEthosUserNamePreferedLast?: string;
    RoEthosUserNameLastPrefered?: string;
    RoEthosUserNameLastFirstPreferedStatus?: string;
    RoEthosUserNameLastFirstPreferedType?: string;
    EthosLaborMetricsHoursCurrentWeek?: number;
    EthosLaborMetricsHoursLastWeek?: number;
    EthosLaborMetricsAverageHours4Week?: number;
    EthosLaborMetricsAverageHours52Week?: number;
    TechEthosRoUserSkillListTimerSkillList?: string;
    // Relations
    TimerType? : TimerTypeEntity;
    TimerStatus? : TimerStatusEntity;
}

/** Entity for Query Meaning Job_Timers_List  */
export interface JobTimersListQueryEntity extends DwOrmData {
    // Attributes
    TimerId?: number;
    TimerStatusId?: number;
    TimerTypeId?: number;
    Ethos_JobId?: number;
    TechEthos_UserId?: number;
    StartDateTime?: string;
    DueDateTime?: string;
    TimerMinutes?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Ethos_JobSiteId?: number;
    Notes?: string;
    EthosAddressCity?: string;
    EthosAddressStateProvinceId?: number;
    // Relations
    TimerType? : TimerTypeEntity;
    TimerStatus? : TimerStatusEntity;
}

    // Lookup Value Enums  {
export enum TimerStatusAllItems {
        Active = 1,
        Complete = 2,
        Stopped = 3,
    }

export enum TimerStatusWithSort {
        Num1Active = 1,
        Num3Complete = 2,
        Num2Stopped = 3,
    }

export enum TimerTypeAllItems {
        JobTimer = 1,
        TechTimer = 2,
    }




